module.exports = __webpack_public_path__ + "img/72.1f5af201.jpg";